<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mt-2 mb-4" />
        <h1 class="text-title-underline">カレンダー</h1>
        <div>
          <iframe
            class="calendar"
            frameborder="0"
            scrolling="no"
            src="https://calendar.google.com/calendar/embed?src=90i599606q9qionq2ljqm1pl7k%40group.calendar.google.com&ctz=Asia%2FTokyo" />
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()

    return {
      t,
      store,
    }
  },
})
</script>

<style scoped>
.calendar {
  border:solid 1px #777;
  width: 100%;
  height: 70vh;
}
</style>